import * as API from '@siloreal:shared:api';

const TAG_SELECTOR_ENDPOINT = '/tags/tag/selector';

export type TagSelectorQueryValue = string | number | boolean | undefined | null;

/**
 * Same filter semantics as the silobag list endpoint: the selector returns the
 * tags linked to the silobags the user can see that match these filters.
 */
export type TagSelectorQuery = Partial<{
  organization_id: TagSelectorQueryValue;
  active: TagSelectorQueryValue;
}>;

export type TagSelectorServiceContract = {
  query?: TagSelectorQuery;
  signal?: AbortSignal;
};

export async function listTagSelectorService(
  contract: TagSelectorServiceContract = {}
): Promise<TagSelectorResponse> {
  const { data } = await API.http.fetch.get<TagSelectorResponse>(TAG_SELECTOR_ENDPOINT, {
    query: buildTagSelectorQuery(contract.query),
    signal: contract.signal,
  });

  return data;
}

export function buildTagSelectorQuery(query?: TagSelectorQuery): string {
  const queryParameters = new URLSearchParams();

  Object.entries(query ?? {}).forEach(([key, value]) => {
    if (value === null || value === undefined) return;

    queryParameters.set(key, String(value));
  });

  const serializedQuery = queryParameters.toString();

  return serializedQuery ? `?${serializedQuery}` : '';
}

export type TagSelectorResponse = {
  error: boolean;
  response: TagSelectorItem[];
};

export type TagSelectorItem = {
  id: number;
  label: string;
  bg_color: string;
  text_color: string;
  scope: {
    value: 'organization' | 'system';
  };
  translations: TagSelectorTranslation[];
  active: boolean;
  image_url: string | null;
  created_at: string;
  updated_at: string;
};

export type TagSelectorTranslation = {
  language?: string;
  value?: string;
  [key: string]: string | undefined;
};
